import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import DataTable from '../../../components/DataTable';
import { TemplateField } from '../../../components/Attributes/Attributes_old';
import Button from '../../../components/Button';

import useAsync from '../../../hooks/useAsync';
import useModal from '../../../hooks/useModal';

import {
	getIntegrationMetrics,
	getIntegrationSources,
	removeIntegration,
	updateIntegration,
} from '../../../api/company';

const Configure = ({ integration, onRefresh }) => {
	const navigate = useNavigate();

	const { setOpen: onOpenDeleteModal, setClose: onCloseDeleteModal } =
		useModal('deleteModal');

	const [form, setForm] = useState({});

	const { execute: onUpdateIntegration, status: updatingIntegration } =
		useAsync(updateIntegration, { immediate: false });

	const { execute: onRemoveIntegration, status: removingIntegration } =
		useAsync(removeIntegration, { immediate: false });

	const {
		value: integrationSources,
		status: loadingIntegrationSources,
		//execute: onRefreshIntegrationSources,
	} = useAsync(getIntegrationSources, {
		defaultPayload: { id: integration?.id },
	});

	const {
		value: integrationMetrics,
		status: loadingIntegrationMetrics,
		//execute: onRefreshIntegrationSources,
	} = useAsync(getIntegrationMetrics, {
		defaultPayload: { id: integration?.id },
	});

	const orgIntegration = integration?.organizations?.length
		? integration?.organizations[0]?.organization_integration
		: null;

	useEffect(() => {
		if (orgIntegration) {
			setForm(orgIntegration);
		}
	}, [orgIntegration]);

	const isActive = !!orgIntegration;

	return (
		<>
			<div className="p-5 border rounded">
				<div className=" grid gap-x-4 gap-y-8 grid-cols-4">
					<TemplateField name="URL" value={integration?.apiUrl} disabled />
					<TemplateField
						name="API Key"
						onChange={(index, apiKey) => setForm({ ...form, apiKey })}
						value={form?.apiKey}
					/>
				</div>
				<div className="flex justify-end mt-4">
					{isActive && (
						<Button
							type="danger"
							className="mr-3"
							onClick={() =>
								onOpenDeleteModal({
									title:
										'Are you sure you want to remove this integration from your app?',
									confirmText: 'Remove',
									onConfirm: () =>
										onRemoveIntegration({ id: integration?.id }, () => {
											onCloseDeleteModal();
											navigate(`/settings/integrations`);
										}),
								})
							}
						>
							Remove Integration
						</Button>
					)}
					<Button
						onClick={() =>
							onUpdateIntegration({ id: integration?.id, ...form }, () =>
								onRefresh({ id: integration?.id }, null, { silent: true })
							)
						}
						disabled={updatingIntegration === 'pending'}
					>
						{isActive
							? updatingIntegration === 'pending'
								? 'Updating...'
								: 'Update'
							: updatingIntegration === 'pending'
							? 'Saving...'
							: 'Save'}
					</Button>
				</div>
			</div>
			{isActive && (
				<>
					<div className="mt-10">
						<h3>Available Sources</h3>

						<ul
							role="list"
							className="divide-y divide-gray-100 rounded-md border border-gray-200 mt-4"
						>
							{integrationSources?.length ? (
								integrationSources?.map((source) => (
									<li className="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
										<div className="flex w-0 flex-1 items-center">
											<div className="text-gray-400 font-bold text-xs w-10">
												{source?.method}
											</div>
											<div className="ml-4 flex min-w-0 flex-1 gap-2">
												<span className="truncate font-medium">
													{source?.name}
												</span>
												<span className="flex-shrink-0 text-gray-400">
													{source?.url}
												</span>
											</div>
										</div>
									</li>
								))
							) : (
								<div>No sources found</div>
							)}
						</ul>
					</div>

					<div className="mt-10">
						<h3>Metrics</h3>

						<DataTable
							columns={[
								{
									header: 'NAME',
									accessorKey: 'name',
									cell: (info) => info?.getValue() || null,
								},
								{
									header: 'SOURCE',
									accessorKey: 'source',
									cell: (info) =>
										info?.row?.original?.integration_source?.name || null,
								},
								{
									header: 'CREATED BY',
									accessorKey: 'createdBy',
									cell: (info) =>
										info?.row?.original?.user
											? `${info?.row?.original?.user?.firstName} ${info?.row?.original?.user?.lastName}`
											: null,
								},
								{
									header: 'LAST UPDATED',
									accessorKey: 'lastUpdated',
									cell: (info) => info?.getValue() || null,
								},
							]}
							data={{
								rows: integrationMetrics || [],
							}}
							usePagination={false}
							useExport={false}
							hasCheckboxes={false}
							useSearch={false}
						/>
					</div>
				</>
			)}
		</>
	);
};

export default Configure;
